export default {"src":"/_next/static/media/dobrozem-smile.bd1dac1c.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};